import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  const title = props.title ?? "Project";
  const hasGithub = Boolean(props.ghLink);
  const hasDemo = Boolean(props.demoLink);
  const tags = Array.isArray(props.tags) ? props.tags : [];
  const stack = Array.isArray(props.stack) ? props.stack : [];

  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt={`Screenshot of ${title}`} />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        {tags.length > 0 && (
          <div className="project-tags" aria-label="Project tags">
            {tags.map((t) => (
              <span key={t} className="project-tag">
                {t}
              </span>
            ))}
          </div>
        )}
        {props.oneLiner && (
          <div className="project-one-liner">{props.oneLiner}</div>
        )}

        {props.problem && (
          <>
            <div className="project-subtitle">Problem</div>
            <div className="project-paragraph">{props.problem}</div>
          </>
        )}

        {props.solution && (
          <>
            <div className="project-subtitle">Solution</div>
            <div className="project-paragraph">{props.solution}</div>
          </>
        )}

        {stack.length > 0 && (
          <>
            <div className="project-subtitle">Tech stack</div>
            <div className="project-stack">
              {stack.map((s) => (
                <span key={s} className="project-stack-pill">
                  {s}
                </span>
              ))}
            </div>
          </>
        )}

        {props.impact && (
          <>
            <div className="project-subtitle">Impact</div>
            <div className="project-paragraph">{props.impact}</div>
          </>
        )}

        {!props.problem && !props.solution && !props.impact && (
          <Card.Text style={{ textAlign: "justify" }}>{props.description}</Card.Text>
        )}
        {hasGithub && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        )}

        {!props.isBlog && hasDemo && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: hasGithub ? "10px" : undefined }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
